import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Config } from '../../../config/config';
import { KeyboardShortcuts, Unlisten } from '../../../keyboard-shortcuts/keyboard-shortcuts';
import { SharedDataService } from '../../../service/shared-data.service';

@Component({
  selector: 'app-lite-dashboard',
  templateUrl: './lite-dashboard.component.html',
  styleUrls: ['./lite-dashboard.component.scss']
})
export class LiteDashboardComponent implements OnInit, OnDestroy
{

    storyFLag: string;
    shownav: string;
    pageName = 'liteStoryheader';
    private keyboardShortcuts: KeyboardShortcuts;
    private unlisten: Unlisten;
  
    message: string;
    onlineFlag = true;
    onlineCheckInterval: any;
    storyEditor = false;
    constructor(
      public config: Config,
      private route: ActivatedRoute,
      keyboardShortcuts: KeyboardShortcuts,
      private router: Router,
      private sharedService: SharedDataService
    ) {
      this.keyboardShortcuts = keyboardShortcuts;
      this.unlisten = null;
     //this.jqueryforDashboard();
    }
  
  
    ngOnInit() {
      //this.jqueryforDashboard();
      this.checkRoute();
      this.router.events.subscribe((val) => {
        if (val instanceof NavigationEnd) {
          this.checkRoute();
        }
      });
      this.sharedService.getData().subscribe(x => {
        if (x === 'storyEditor|true') {
          this.storyEditor = true;
        }
        if (x === 'storyEditor|false') {
          this.storyEditor = false;
        }
      });
      //console.log(window.innerWidth);
    }
  
    checkRoute() {
      if (this.router.routerState.snapshot.url.indexOf('story/') > 0) {
        this.storyEditor = true;
      } else if (this.router.routerState.snapshot.url.indexOf('element/') > 0) {
        this.storyEditor = true;
      } else if (this.router.routerState.snapshot.url.indexOf('page/') > 0) {
        this.storyEditor = true;
      } else if (this.router.routerState.snapshot.url.indexOf('nav-manager/') > 0 ||
      this.router.routerState.snapshot.url.indexOf('footer-manager/') > 0) {
        this.storyEditor = true;
      } else if (this.router.routerState.snapshot.url.indexOf('dash/') > 0) {
        this.storyEditor = false;
      }
    }
    @HostListener('window:online', ['$event'])
    onlinecheck(event) {
      this.onlineFlag = true;
    }
    @HostListener('window:offline', ['$event'])
    offlinecheck(event) {
      this.onlineFlag = false;
    }
  
    @HostListener('window:focus', ['$event'])
    focuscheck(event) {
    }
  
    @HostListener('window:blur', ['$event'])
    blurcheck(event) {
    }
  
    ngOnDestroy() {
      if (this.onlineCheckInterval) {
        clearInterval(this.onlineCheckInterval);
      }
      (this.unlisten) && this.unlisten();
    }
  }
  

